"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkGroup = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var R = _interopRequireWildcard(require("ramda"));

var _Icons = require("./Icons");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var LinkGroup =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LinkGroup, _React$Component);

  function LinkGroup(props) {
    var _this;

    _classCallCheck(this, LinkGroup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LinkGroup).call(this, props));
    _this.state = {
      sideNavState: _this.props.collapsed
    };
    return _this;
  }

  _createClass(LinkGroup, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!nextProps.expanded) {
        this.setState({
          sideNavState: nextProps.collapsed
        });
      }

      if (nextProps.collapsed !== this.props.collapsed && !this.props.collapsed) {
        this.props.onClick(false, this.props.label);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var classes = "".concat(this.props.className || '', " vs-sidenav-entry vs-sidenav-container") + (this.props.expanded && !this.props.collapsed ? ' expanded' : '');

      var expandRow = function expandRow() {
        _this2.props.onClick(!_this2.props.expanded, _this2.props.label);

        if (_this2.props.expanded) {
          _this2.props.toggleSideNav(_this2.state.sideNavState);
        } else {
          _this2.props.toggleSideNav(_this2.props.expanded);
        }
      };

      var icon = !R.isNil(this.props.svgIcon) ? _react.default.createElement(_Icons.SideNavSvgIcon, null, this.props.svgIcon) : !R.isNil(this.props.icon) ? this.props.icon : (0, _Icons.makeDefaultIcon)(this.props.label);
      return _react.default.createElement("li", {
        className: classes
      }, _react.default.createElement("a", {
        className: "vs-sidenav-container-row",
        onClick: expandRow,
        title: this.props.label
      }, _react.default.createElement("div", {
        className: "vs-sidenav-container-row-left"
      }, icon, _react.default.createElement("span", {
        className: "vs-sidenav-container-label"
      }, this.props.label)), _react.default.createElement("i", {
        className: "fa fa-chevron-right vs-sidenav-container-chevron"
      })), _react.default.createElement("ul", {
        className: "vs-link-group-children"
      }, this.props.children));
    }
  }]);

  return LinkGroup;
}(_react.default.Component);

exports.LinkGroup = LinkGroup;
LinkGroup.propTypes = {
  expanded: _propTypes.default.bool,
  onClick: _propTypes.default.func.isRequired,
  label: _propTypes.default.string.isRequired,
  toggleSideNav: _propTypes.default.func.isRequired
};